import { render, staticRenderFns } from "./RegistreHistory.vue?vue&type=template&id=3853c2c4&"
import script from "./RegistreHistory.vue?vue&type=script&lang=js&"
export * from "./RegistreHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports